import { useEffect, useRef } from "react";

export const PRACTICE_NOTICE =
  "Practising a finished lesson doesn't change your place in the sequence.";

/**
 * Opened from No expectation mode's Finished tab (`fromTab=finished`, set by
 * the student's lesson card): practising never moves the student's place, and the
 * design says so as the lesson opens (Alloy, student v7). Once per load,
 * however often the player rewrites its URL.
 */
export function usePracticeNotice(
  searchParams: URLSearchParams,
  notify: (message: string, type?: undefined, durationMs?: number) => void,
): void {
  const shown = useRef(false);
  useEffect(() => {
    if (shown.current || searchParams.get("fromTab") !== "finished") return;
    shown.current = true;
    notify(PRACTICE_NOTICE, undefined, 6000);
  }, [searchParams, notify]);
}
